<h2>{{hero.name}} Details</h2>
<div><span>id: </span>{{hero.id}}</div>

<div>
  <label>name:
    <input [(ngModel)]="hero.name" placeholder="name" />
  </label>
</div>
